/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useBackupsConfigureStyles = makeStyles(theme => ({
  root: {
    minWidth: '650px',
  },
  colLeft: {
    display: 'flex',
    marginRight: '48px',
  },
  colRight: {
    marginLeft: '10px',
    flexBasis: '320px',
  },
  headingWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  headingOffset: {
    margin: '0 0 24px 0',
  },
  heading: {
    color: theme.palette.primary.main,
    fontSize: '20px',
    lineHeight: '24px',
  },
  cancelBackup: {
    marginLeft: '10px',
  },
  h3: {
    fontSize: '16px',
    lineHeight: '24px',
  },
  noBackups: {
    color: '#A2A7AE',
    lineHeight: '16px',
    letterSpacing: '-0.52px',
    margin: '8px 0 0',
  },
  formControl: {
    width: '200px',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 16px 0 0',
  },
  timeHeading: {
    marginBottom: '16px',
  },
  timeLine: {
    fontSize: '12px',
    paddingLeft: '5px',
  },
  timeLabel: {
    fontSize: '14px',
    lineHeight: '14px',
    marginBottom: '5px',
  },
  timeContainer: {
    marginTop: '5px',
    marginLeft: '5px',
    display: 'flex',
  },
  timeBottom: {
    fontWeight: 500,
  },
  backupsTable: {
    marginTop: '40px',
  },
  buttonApply: {
    margin: '16px 16px 16px 0',
  },
  backupNowButton: {
    margin: '16px 0',
  },
  backupNowBlock: {
    // marginTop: "10px",
  },
  alert: {
    margin: '16px 0 68px',
  },
  backupRestorePoint: {
    display: 'flex',
    marginTop: '8px',
  },
  backupRestoreIcon: {
    width: '32px',
    height: '32px',
    backgroundColor: '#F6F7F8',
    borderRadius: '6px',
    padding: '5px',
    marginRight: '10px',
  },
  backupSizeLabel: {
    marginTop: '12px',
  },
  configureBackupLabel: {
    margin: '0 0 20px 0',
    color: theme.palette.primary.main,
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 'bold',
  },
  restoreSize: {
    marginTop: '12px',
    marginLeft: '5px',
  },
}));
